/**
 * When true, users can choose French puzzle content (catalog, settings, samples).
 * Set REACT_APP_SUPPORT_FRENCH=true to enable French puzzles.
 */
export const SUPPORT_FRENCH =
    typeof process !== "undefined" && process.env.REACT_APP_SUPPORT_FRENCH === "true";
